<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame" epub:type="copyright-page" id="_idContainer005">
<p class="_cip" id="_idParaDest-2">Copyright Information</p>
<p class="cip2-spab"><span epub:type="pagebreak" id="pagevi" title="vi"><span class="ital">Priestess of the Morrigan: Prayers, Rituals &amp; Devotional Work to the Great Queen</span> © 2021 by Stephanie Woodfield. </span></p>
<p class="cip1-nosp">All rights reserved. No part of this book may be used or reproduced in any matter whatsoever, including Internet usage, without written permission from Llewellyn Publications, except in the form of brief quotations embodied in critical articles and reviews.</p>
<p class="cip2-spab">As the purchaser of this e-book, you are granted the non-exclusive, non-transferable right to access and read the text of this e-book on screen. The text may not be otherwise reproduced, transmitted, downloaded, or recorded on any other storage device in any form or by any means. </p>
<p class="cip2-spab">Any unauthorized usage of the text without express written permission of the publisher is a violation of the author’s copyright and is illegal and punishable by law.</p>
<p class="cip2-spab">First e-book edition © 2021</p>
<p class="cip1-nosp">E-book ISBN: 9780738766812</p>
<p class="cip2-spab">Cover design by Kevin R. Brown</p>
<p class="cip1-nosp">Interior illustrations by Eugene Smith</p>
<p class="cip1-nosp">Interior illustration on <a href="#/PM19#_idTextAnchor032">page 192</a> by Llewellyn Art Department</p>
<p class="cip2-spab">Llewellyn Publications is an imprint of Llewellyn Worldwide Ltd.</p>
<p class="cip2-spab">Library of Congress Cataloging-in-Publication Data</p>
<p class="cip1-nosp">Names: Woodfield, Stephanie, author. </p>
<p class="cip1-nosp">Title: Priestess of the Morrigan : prayers, rituals &amp; devotional work to</p>
<p class="cip1-nosp">   the great queen / Stephanie Woodfield. </p>
<p class="cip1-nosp">Description: First edition. | Woodbury, Minnesota : Llewellyn Publications,</p>
<p class="cip1-nosp">   2021. | Includes bibliographical references and index. | Summary:</p>
<p class="cip1-nosp">   “Stephanie Woodfield, a devotee to the Morrigan for over twenty years,</p>
<p class="cip1-nosp">   offers stories, prayers, and rituals for groups or solitaries engaged in</p>
<p class="cip1-nosp">   devotional practice to the Irish goddess”– Provided by publisher. </p>
<p class="cip1-nosp">Identifiers: LCCN 2020041390 (print) | LCCN 2020041391 (ebook) | ISBN</p>
<p class="cip1-nosp">   9780738766652 | ISBN 9780738766812 (ebook) </p>
<p class="cip1-nosp">Subjects: LCSH: Morrigan (Celtic deity) | Goddesses, Celtic—Ireland.</p>
<p class="cip1-nosp">Classification: LCC BL915.M67 W66 2021  (print) | LCC BL915.M67  (ebook) |</p>
<p class="cip1-nosp">   DDC 299–dc23</p>
<p class="cip1-nosp">LC record available at https://lccn.loc.gov/2020041390</p>
<p class="cip1-nosp">LC ebook record available at https://lccn.loc.gov/2020041391</p>
<p class="cip2-spab">Llewellyn Publications does not participate in, endorse, or have any authority or responsibility concerning private business arrangements between our authors and the public.</p>
<p class="cip2-spab">Any Internet references contained in this work are current at publication time, but the publisher cannot guarantee that a specific reference will continue or be maintained. Please refer to the publisher’s website for links to current author websites.</p>
<p class="cip3-spab-cntr">Llewellyn Publications </p>
<p class="cip34-nosp-cntr">Llewellyn Worldwide Ltd.</p>
<p class="cip34-nosp-cntr">2143 Wooddale Drive</p>
<p class="cip34-nosp-cntr">Woodbury, MN 55125</p>
<p class="cip34-nosp-cntr"><a href="http://www.llewellyn.com" target="_blank">www.llewellyn.com</a></p>
<p class="cip3-spab-cntr">Manufactured in the United States of America</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Copyright.vue?f4d40064